import './setPublicPath'
import Vue from 'vue'
import wrap from '@vue/web-component-wrapper'

// runtime shared by every component chunk
import 'css-loader/dist/runtime/api.js'
import 'vue-style-loader/lib/addStylesShadow'
import 'vue-loader/lib/runtime/componentNormalizer'

import Button from '~root/src/components/Button/Button.vue?shadow'
window.customElements.define('basecoat-components-button', wrap(Vue, Button))

import Checkbox from '~root/src/components/Checkbox/Checkbox.vue?shadow'
window.customElements.define('basecoat-components-checkbox', wrap(Vue, Checkbox))

import CheckboxOption from '~root/src/components/Checkbox/CheckboxOption.vue?shadow'
window.customElements.define('basecoat-components-checkbox-option', wrap(Vue, CheckboxOption))

import CheckboxOptionSlot from '~root/src/components/Checkbox/CheckboxOptionSlot.vue?shadow'
window.customElements.define('basecoat-components-checkbox-option-slot', wrap(Vue, CheckboxOptionSlot))

import DatePicker from '~root/src/components/Date/DatePicker.vue?shadow'
window.customElements.define('basecoat-components-date-picker', wrap(Vue, DatePicker))

import Dropdown from '~root/src/components/Dropdown/Dropdown.vue?shadow'
window.customElements.define('basecoat-components-dropdown', wrap(Vue, Dropdown))

import DropdownOption from '~root/src/components/Dropdown/DropdownOption.vue?shadow'
window.customElements.define('basecoat-components-dropdown-option', wrap(Vue, DropdownOption))

import DropdownOptionSlot from '~root/src/components/Dropdown/DropdownOptionSlot.vue?shadow'
window.customElements.define('basecoat-components-dropdown-option-slot', wrap(Vue, DropdownOptionSlot))

import Search from '~root/src/components/Dynamic/Search.vue?shadow'
window.customElements.define('basecoat-components-search', wrap(Vue, Search))

import FilePicker from '~root/src/components/File/FilePicker.vue?shadow'
window.customElements.define('basecoat-components-file-picker', wrap(Vue, FilePicker))

import HelloWorld from '~root/src/components/Hello/HelloWorld.vue?shadow'
window.customElements.define('basecoat-components-hello-world', wrap(Vue, HelloWorld))

import Input from '~root/src/components/Input/Input.vue?shadow'
window.customElements.define('basecoat-components-input', wrap(Vue, Input))

import Menu from '~root/src/components/Menu/Menu.vue?shadow'
window.customElements.define('basecoat-components-menu', wrap(Vue, Menu))

import MenuCategory from '~root/src/components/Menu/MenuCategory.vue?shadow'
window.customElements.define('basecoat-components-menu-category', wrap(Vue, MenuCategory))

import MenuLink from '~root/src/components/Menu/MenuLink.vue?shadow'
window.customElements.define('basecoat-components-menu-link', wrap(Vue, MenuLink))

import MenuSlot from '~root/src/components/Menu/MenuSlot.vue?shadow'
window.customElements.define('basecoat-components-menu-slot', wrap(Vue, MenuSlot))

import Modal from '~root/src/components/Modal/Modal.vue?shadow'
window.customElements.define('basecoat-components-modal', wrap(Vue, Modal))

import MultiDropdown from '~root/src/components/MultiDropdown/MultiDropdown.vue?shadow'
window.customElements.define('basecoat-components-multi-dropdown', wrap(Vue, MultiDropdown))

import MultiDropdownOption from '~root/src/components/MultiDropdown/MultiDropdownOption.vue?shadow'
window.customElements.define('basecoat-components-multi-dropdown-option', wrap(Vue, MultiDropdownOption))

import MultiDropdownOptionSlot from '~root/src/components/MultiDropdown/MultiDropdownOptionSlot.vue?shadow'
window.customElements.define('basecoat-components-multi-dropdown-option-slot', wrap(Vue, MultiDropdownOptionSlot))

import NavBar from '~root/src/components/NavBar/NavBar.vue?shadow'
window.customElements.define('basecoat-components-nav-bar', wrap(Vue, NavBar))

import Page from '~root/src/components/Page/Page.vue?shadow'
window.customElements.define('basecoat-components-page', wrap(Vue, Page))

import Panel from '~root/src/components/Panel/Panel.vue?shadow'
window.customElements.define('basecoat-components-panel', wrap(Vue, Panel))

import PanelSlot from '~root/src/components/Panel/PanelSlot.vue?shadow'
window.customElements.define('basecoat-components-panel-slot', wrap(Vue, PanelSlot))

import Panels from '~root/src/components/Panel/Panels.vue?shadow'
window.customElements.define('basecoat-components-panels', wrap(Vue, Panels))

import Radio from '~root/src/components/Radio/Radio.vue?shadow'
window.customElements.define('basecoat-components-radio', wrap(Vue, Radio))

import RadioOption from '~root/src/components/Radio/RadioOption.vue?shadow'
window.customElements.define('basecoat-components-radio-option', wrap(Vue, RadioOption))

import RadioOptionSlot from '~root/src/components/Radio/RadioOptionSlot.vue?shadow'
window.customElements.define('basecoat-components-radio-option-slot', wrap(Vue, RadioOptionSlot))

import Section from '~root/src/components/Section/Section.vue?shadow'
window.customElements.define('basecoat-components-section', wrap(Vue, Section))

import SectionHeader from '~root/src/components/Section/SectionHeader.vue?shadow'
window.customElements.define('basecoat-components-section-header', wrap(Vue, SectionHeader))

import Toggle from '~root/src/components/Toggle/Toggle.vue?shadow'
window.customElements.define('basecoat-components-toggle', wrap(Vue, Toggle))